export default [
    { //其它担保公司列表
        path: '/guaranteeManagement/companyList',
        name:'guaranteeManagementCompanyList',
        meta: { title: '其它担保公司列表'},
        component: () => import('../../views/guaranteeManagement/companyList.vue')
    },
    { //担保公司明细
        path: '/guaranteeManagement/company/detail',
        name:'guaranteeManagementCompanyDetail',
        meta: { title: '担保公司明细'},
        component: () => import('../../views/guaranteeManagement/companyDetail.vue')
    },
    { //其它担保公司担保申请列表
        path: '/guaranteeManagement/otherApplyList',
        name:'guaranteeManagementOtherApplyList',
        meta: { title: '其它担保公司担保申请列表'},
        component: () => import('../../views/guaranteeManagement/otherApplyList.vue')
    },
    { //担保公司详情
        path: '/guaranteeManagement/otherApplyDetail',
        name:'guaranteeManagementOtherApplyDetail',
        meta: { title: '担保公司详情'},
        component: () => import('../../views/guaranteeManagement/otherApplyDetail.vue')
    },
    { //其它担保公司担保申请详情
      path: '/guaranteeManagement/otherApplyList/detail/:id',
      name:'guaranteeManagementOtherApplyListDetail',
      meta: { title: '其它担保公司担保申请详情'},
      component: () => import('../../views/guaranteeManagement/otherApplyListDetail.vue')
  },
    { //经开区中小担申请列表
        path: '/guaranteeManagement/applyList',
        name:'guaranteeManagementApplyList',
        meta: { title: '经开区中小担申请列表'},
        component: () => import('../../views/guaranteeManagement/applyList.vue')
    },
    { //经开区中小担申请详情
      path: '/guaranteeManagement/applyList/detail/:id',
      name:'guaranteeManagementApplyListDetail',
      meta: { title: '经开区中小担申请详情'},
      component: () => import('../../views/guaranteeManagement/applyListDetail.vue')
  },
]